import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=60b3a5d0&scoped=true&"
import script from "./StoreList.vue?vue&type=script&lang=js&"
export * from "./StoreList.vue?vue&type=script&lang=js&"
import style0 from "./StoreList.vue?vue&type=style&index=0&id=60b3a5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3a5d0",
  null
  
)

export default component.exports